/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Booking from './Booking/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/AppointmentSelect/Content/Content/AppointmentSelect/Content/Content/Appointments/Appointment"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let appointmentOverlayAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_id',
})
let appointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: '_id',
})
let aggregateData = fromAggregate.equals(appointmentOverlayAppointmentIdValueData, appointmentIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  closePopover,
  viewPath,
  isHovered
  
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let appointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'type.display_color_id',
format: fromFormat.appointmentTypeColor,
})
let appointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'type.display_name',
})
  return (<React.Fragment
>
<button
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--btlr-1-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-2-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-5-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-7-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-8-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-9-dUIJ5': isHovered ? dtColorsNeutral100 : aggregateData ? dtColorsNeutral100 : "initial"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 style={{'--g-10-dUIJ5': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Appointment.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-9-dUIJ5': appointmentTypeDisplayColorIdValueData,'--h-11-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-12-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.type.display_name"
 text={appointmentTypeDisplayNameValueData}
/>
</div>
<Booking
  viewPath={`${viewPath}/Booking`}
/>
</button>
{children}
</React.Fragment>)
}